import { PinscomConfig } from '@PetSureAustralia/petsure-brand-partner-configs/distConfigs/brandConfigs';
import { MakeConfig } from '../../helpers/configHelper';

export const QuoteToolConfigs = MakeConfig({
  config: PinscomConfig,
  brokerFriendlyName: 'PINSCOM'
});
